// extracted by mini-css-extract-plugin
export default {"singleProperty":"ToggleSelector_singleProperty__YzO2p","switch":"ToggleSelector_switch__GKDvu"};